import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
  schema?: object | object[];
}

export const SEOHead = ({
  title = 'Compaws | Cuidadores de mascotas verificados en El Salvador',
  description = 'Encuentra cuidadores de mascotas verificados en El Salvador. Pet sitting, paseos y cuidado a domicilio en San Salvador, Antiguo Cuscatlán, Santa Tecla y más.',
  canonical = 'https://somoscompaws.com',
  ogImage = 'https://somoscompaws.com/lovable-uploads/d4167bdc-fee8-46ee-82fb-52c880b10d47.png',
  schema,
}: SEOHeadProps) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href={canonical} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={ogImage} />
    <meta property="og:url" content={canonical} />
    <meta property="og:locale" content="es_SV" />
    <meta property="og:type" content="website" />
    <meta property="og:site_name" content="Compaws" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={ogImage} />
    {schema && (Array.isArray(schema) ? schema : [schema]).map((s, i) => (
      <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
    ))}
  </Helmet>
);
